<template>
  <div class="Noses">    
    <svg viewBox="0 0 1686.22 2248.29">  
      <path class="cls-1" :class="color_used" v-if="this.portrait.noses == 'nose_01'" d="M851.24,895.46c-11,10-17,59-22,68s-7,27-7,27,28,15,44,17,48-24,48-24-10-23-17-36-21-39-29-45A38.64,38.64,0,0,0,851.24,895.46Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.noses == 'nose_02'" d="M852.27,865.5c.93,0,10.35-14.3,18-15,8.84-.8,16,12,16,12l34,118s-9,16-17,17-7-28-17-29c-2.22-.22-10,8-9,19s-2,21-10,20-16-24-12-34-11-8-15-6,0,31-5,31-18-7-19-15,9-37,15-48S852.27,865.5,852.27,865.5Z"/>  
      <polygon class="cls-1" :class="color_used" v-if="this.portrait.noses == 'nose_03'" points="803.38 986.17 867.57 1007.57 933.1 990.19 917.05 964.78 888.97 948.73 879.61 861.8 859.55 856.46 846.17 915.3 840.82 952.74 811.4 966.12 803.38 986.17"/>
      <path class="cls-1" :class="color_used" v-if="this.portrait.noses == 'nose_04'" d="M916.92,929.72c-8.89-.89-22,14.11-28.6,10.67s-11.52-48.2-11.52-48.2-19.74-10.33-24.67,0,1.64,34.43-3.29,41.31-21.39-1.72-29.61-13.77-16.45,29.26-9.87,39.59,51,46.47,60.86,48.19,54.29-34.42,57.58-41.31S930.72,931.11,916.92,929.72Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.noses == 'nose_05'" d="M899.13,933.38c-4.68-17.58-11.83-41.15-16.53-41.15-7.5,0-27.48,5-27.48,5L833.85,934.7c-7.61,4.93-21.57,14.57-21.57,14.57l-9.22,13.49s29.86,16.66,37.66,24.64S866,1007.57,866,1007.57l36.1-27.72,20-11.39,11.31-9.39S914.2,943.66,899.13,933.38Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.noses == 'nose_06'" d="M946.28,978.64,926,947.45a43,43,0,0,0-21.67-17.06l-17.09-47s-19.28-6-28.93,0S839,932.83,839,932.83c-10.85,3.62-43.4,27.73-47,30.14-1.73,1.15-4,7-5.92,12.78a20.57,20.57,0,0,0,15.68,26.73,37.75,37.75,0,0,0,10.73.27c22.91-2.41,32.55-14.46,32.55-14.46s12,19.28,35.56,19.28a41.28,41.28,0,0,0,34.36-18.08s13.13,12.88,18.08,13.26C964.36,1005.16,946.28,978.64,946.28,978.64Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.noses == 'nose_07'" d="M867.89,893.11c-25.4,0-40,15.82-42.8,19.54s-14.89,37.22-14.89,46.52,6.52,40,12.1,43.73,15.82,10.24,22.33-4.65,5.58-44.66,5.58-44.66,7.45-3.72,8.38-2.79-2.8,46.52,7.44,50.24,22.33-3.72,22.33-14.88-3.72-30.71,0-35.36,6.51-3.72,6.51-3.72-.93,43.73,5.59,48.38,16.74,7.44,22.33,2.79,2.79-45.59,2.79-55.82-10.24-29.78-13-31.64S891.15,893.11,867.89,893.11Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.noses == 'nose_08'" d="M848.59,909.57l-24.07,67s1.59,17.77,8.14,25.82,35.61,5.5,56.58.81,26.15-57,20.72-78.12-1.4-34.34-12.73-57.06-29.36-29.09-30.1-29.29S848.59,909.57,848.59,909.57Zm12.88,43.65s9.28-2.28,11.69-2.43,7-47.06,6.61-48.73,5.88-10.27,5.88-10.27,3.63,30.94,4.94,55.74-26,35.69-26,35.69-15.86-2.63-19.95-14S861.47,953.22,861.47,953.22Z"/>  

      <!-- <path class="cls-1" :class="color_used" v-if="this.portrait.hair == 'hair_16'"  -->

    </svg>
  </div>
</template>

<script>

export default {
  name: 'Noses',
  data: ()=>({
    indice: 'noses',
    default_color: 'grey',
    color_used: 'grey',
  }),
  computed: { 
    categorie() { return this.$store.getters['app/categorie'] },
    portrait() { return this.$store.getters['app/portrait'] },
    color() { return this.$store.getters['app/color'] },
    reset_color() { return this.$store.getters['app/reset_color'] },
    colors() { return this.$store.getters['app/colors'] },
  },
    mounted() {
    if(this.colors[this.indice]) 
      this.color_used = this.colors[this.indice]
  },
  watch: {
    color(nw, od) {
      if(this.categorie == this.indice) {
        this.color_used = nw
      }
    },
    reset_color(nw, od) {
      if(this.categorie == this.indice) {
        this.color_used = this.default_color
      }
    },
    categorie(nw, od) {
      this.$nextTick(()=>{
        if(nw == this.indice)
          this.$store.commit('app/SET_COLOR', this.color_used)
      })
    },

  },

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Noses
  default_color = grey
  svg
    width 100%
    .cls-1 
      fill default_color
      &.green 
        fill asset_green
      &.dark_blue 
        fill asset_dark_blue
      &.orange 
        fill asset_orange
      &.purple 
        fill asset_purple
      &.yellow 
        fill asset_yellow
      &.blue 
        fill asset_blue
      &.pink 
        fill asset_pink
      &.dark_brown 
        fill asset_dark_brown
      &.brown 
        fill asset_brown
      &.red 
        fill asset_red

</style>


// WEBPACK FOOTER //
// src/components/defis/svg/Noses.vue